/**
 * Flags do read model incremental da inbox (workspace_member_inbox_stats).
 *
 * Default: tudo OFF — a UI continua 100% no caminho V1 (RPCs de contagem).
 * Espelha o padrão de `gcal-feature-flags.ts` (aceita true/1/yes, com ou sem aspas).
 */

function isTruthyFlag(value: unknown): boolean {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase().replace(/^["']|["']$/g, "");
  return normalized === "true" || normalized === "1" || normalized === "yes";
}

/** V2 (matriz `workspace_member_inbox_stats`) como fonte das contagens. */
export function isInboxStatsV2Enabled(): boolean {
  return isTruthyFlag(import.meta.env.VITE_INBOX_STATS_V2);
}

/** Shadow: executa V2 em paralelo, devolve V1 e loga divergência. */
export function isInboxStatsShadowEnabled(): boolean {
  return isTruthyFlag(import.meta.env.VITE_INBOX_STATS_SHADOW);
}

/** Taxa de amostragem do shadow no cliente (0..1). Default 0.05. */
export function inboxStatsShadowSampleRate(): number {
  const raw = import.meta.env.VITE_INBOX_STATS_SHADOW_RATE;
  if (typeof raw !== "string" || !raw.trim()) return 0.05;
  const parsed = Number(raw.trim().replace(/^["']|["']$/g, ""));
  if (!Number.isFinite(parsed) || parsed < 0) return 0.05;
  return Math.min(1, parsed);
}

/**
 * Failsafe dos counts por canal: default segue o RPC remoto.
 * Só força legado se a env estiver explicitamente desligada — não liga matriz sozinha.
 */
export function isInboxChannelCountsMatrixForcedLegacy(): boolean {
  const raw = import.meta.env.VITE_INBOX_CHANNEL_COUNTS_MATRIX;
  if (raw === undefined || raw === null) return false;
  if (typeof raw === "string" && !raw.trim()) return false;
  return !isTruthyFlag(raw);
}
